export default function HomePage() {
  return (
    <div>
      <h1>This is the Home Page</h1>
    </div>
  );
}
